/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Rongi 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Gasagara": ["Fumbwe", "Gasharu", "Kidahwe", "Murehe", "Musenyi", "Nyabugombe"],
  "Gasharu": ["Birehe", "Gituza", "Kabirizi", "Kabuga", "Karama", "Nyamiyaga"],
  "Karambo": ["Gifurwe", "Gitwa", "Nyabikenke", "Nyagasozi", "Rushenyi"],
  "Nyamirambo": ["Gisoro", "Kabakungu", "Karambi", "Masizi", "Mugwato", "Ntarabana", "Rugogwe", "Rwamure"],
  "Ruhango": ["Burerabana", "Kondo", "Muyebe", "Rukoma"]
};